import React from 'react'
import InvoiceCardSelectorCard from './invoice-card-selector-card'

const InvoiceCardSelector = ({ cardList, selectedCardIndex, setSelectedCardIndex }) => {
  const creditCardList = cardList.filter(card => card.cardType === "credit");
  const orderedCreditCardList = creditCardList.sort((a, b) => a.isDependent - b.isDependent);
  return (
    <div className="card-selector">
      {
        orderedCreditCardList.map((card, index) => (
          <InvoiceCardSelectorCard key={index} card={card} index={card.id} selectedCardIndex={selectedCardIndex} setSelectedCardIndex={setSelectedCardIndex} />
        ))
      }
    </div>
  )
}

export default InvoiceCardSelector
